"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var utils_1 = require("../utils");

var ActionConverter_1 = require("./ActionConverter");

var ContentConverter_1 = require("./ContentConverter");

var ToggleFunctionConverter_1 = require("./ToggleFunctionConverter");

var TrackerConverter_1 = require("./TrackerConverter");

var SizeConverter_1 = require("./SizeConverter");

var StyleEventConverter_1 = require("./StyleEventConverter");

var FunctionConverter_1 = require("./FunctionConverter");

var OverlayConverter =
/** @class */
function () {
  function OverlayConverter() {}

  OverlayConverter.prototype.fromMessage = function (message) {
    var object = {
      actions: utils_1.withDefault(message.actions, []).map(function (x) {
        return ActionConverter_1.actionConverter.fromMessage(x);
      }),
      baseSize: SizeConverter_1.sizeConverter.fromMessage(utils_1.withDefault(message.baseSize, {
        height: 1,
        width: 1
      })),
      styleEvents: utils_1.withDefault(message.styleEvents, []).map(function (x) {
        return StyleEventConverter_1.styleEventConverter.fromMessage(x);
      })
    };
    if (utils_1.hasValue(message.content)) object.content = ContentConverter_1.contentConverter.fromMessage(message.content);
    if (utils_1.hasValue(message.end)) object.end = ToggleFunctionConverter_1.toggleFunctionConverter.fromMessage(message.end);
    if (utils_1.hasValue(message.onMount)) object.onMount = FunctionConverter_1.functionConverter.fromMessage(message.onMount);
    if (utils_1.hasValue(message.onUnmount)) object.onUnmount = FunctionConverter_1.functionConverter.fromMessage(message.onUnmount);
    if (utils_1.hasValue(message.start)) object.start = ToggleFunctionConverter_1.toggleFunctionConverter.fromMessage(message.start);
    if (utils_1.hasValue(message.tracker)) object.tracker = TrackerConverter_1.trackerConverter.fromMessage(message.tracker);
    return object;
  };

  OverlayConverter.prototype.toMessage = function (object) {
    var message = {
      actions: object.actions.map(function (x) {
        return ActionConverter_1.actionConverter.toMessage(x);
      }),
      baseSize: SizeConverter_1.sizeConverter.toMessage(object.baseSize),
      styleEvents: utils_1.withDefault(object.styleEvents, []).map(function (x) {
        return StyleEventConverter_1.styleEventConverter.toMessage(x);
      })
    };
    if (utils_1.hasValue(object.content)) message.content = ContentConverter_1.contentConverter.toMessage(object.content);
    if (utils_1.hasValue(object.end)) message.end = ToggleFunctionConverter_1.toggleFunctionConverter.toMessage(object.end);
    if (utils_1.hasValue(object.onMount)) message.onMount = FunctionConverter_1.functionConverter.toMessage(object.onMount);
    if (utils_1.hasValue(object.onUnmount)) message.onUnmount = FunctionConverter_1.functionConverter.toMessage(object.onUnmount);
    if (utils_1.hasValue(object.start)) message.start = ToggleFunctionConverter_1.toggleFunctionConverter.toMessage(object.start);
    if (utils_1.hasValue(object.tracker)) message.tracker = TrackerConverter_1.trackerConverter.toMessage(object.tracker);
    return message;
  };

  return OverlayConverter;
}();

exports.OverlayConverter = OverlayConverter;
exports.overlayConverter = new OverlayConverter();